"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Checkbox = require("./Checkbox.Styled");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Checkbox = _ref => {
  let {
    checked,
    onChange,
    label,
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Checkbox.CheckboxContainer, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.Flex, null, /*#__PURE__*/_react.default.createElement(_Checkbox.HiddenCheckbox, {
    checked: checked,
    onChange: () => {}
  }), /*#__PURE__*/_react.default.createElement(_Checkbox.StyledCheckbox, {
    checked: checked,
    onClick: () => onChange(!checked)
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.CheckedIcon, {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react.default.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }))), label && /*#__PURE__*/_react.default.createElement(_Checkbox.Label, {
    onClick: () => onChange(!checked)
  }, label)));
};

var _default = Checkbox;
exports.default = _default;